import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/AuthContext";
import { api } from "../lib/api";
import { ArrowLeft, Send, Loader2, Eye } from "lucide-react";

const TEMPLATES = [
  { key: "mentor-prelaunch", label: "Mentor-Programm Launch" },
  { key: "events-launch", label: "Events Launch 2026" },
];

const BroadcastPage = () => {
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [testTo, setTestTo] = useState("");

  useEffect(() => {
    if (loading) return;
    if (!user || user.role !== "admin") { nav("/admin/login"); }
  }, [user, loading, nav]);

  const loadTemplate = async (key) => {
    const r = await api.get(`/admin/broadcast/preview-template/${key}`);
    setSubject(r.data.subject); setBody(r.data.body_html);
  };

  const send = async (mode) => {
    setBusy(true); setResult(null);
    try {
      const payload = { subject, body_html: body };
      if (mode === "dry") payload.dry_run = true;
      if (mode === "test") payload.test_to = testTo;
      const r = await api.post("/admin/broadcast", payload);
      setResult(r.data);
    } catch (e) {
      setResult({ error: e?.response?.data?.detail || "Fehler" });
    } finally { setBusy(false); }
  };

  if (loading || !user) return <div className="pt-32 text-center text-white/55">Lade…</div>;

  return (
    <div className="pt-24 min-h-screen" data-testid="broadcast-page">
      <div className="max-w-[1100px] mx-auto px-6 lg:px-10 py-8">
        <Link to="/admin" className="btn-ghost text-sm"><ArrowLeft size={14} /> Admin</Link>
        <h1 className="headline-xl text-4xl mt-3">Broadcast an Newsletter-Liste</h1>
        <p className="serif italic text-white/55 mt-2">Sende eine einmalige Mail an alle Abonnenten. Verfügbarer Platzhalter: <code className="text-[#D4AF37]">{"{{first_name}}"}</code></p>

        <div className="flex gap-2 mt-6 flex-wrap">
          {TEMPLATES.map(t => (
            <button key={t.key} onClick={() => loadTemplate(t.key)} className="btn-secondary text-sm" data-testid={`template-${t.key}`}>Vorlage: {t.label}</button>
          ))}
        </div>

        <div className="mt-6 glass rounded-2xl p-6 space-y-3" data-testid="broadcast-form">
          <input className="sat-input" placeholder="Betreff" value={subject} onChange={e => setSubject(e.target.value)} data-testid="broadcast-subject" />
          <textarea className="sat-input font-mono text-xs" rows={14} placeholder="HTML-Body…" value={body} onChange={e => setBody(e.target.value)} data-testid="broadcast-body" />
        </div>

        {body && (
          <div className="mt-6">
            <div className="overline mb-2">Live-Vorschau (mit {"{{first_name}}"} = "Nenad")</div>
            <div className="glass rounded-2xl p-6 prose prose-invert max-w-none" data-testid="broadcast-preview"
              dangerouslySetInnerHTML={{ __html: body.replace(/{{first_name}}/g, "Nenad") }}
            />
          </div>
        )}

        <div className="mt-6 space-y-3">
          <div className="flex flex-wrap gap-3">
            <button onClick={() => send("dry")} disabled={busy || !subject} className="btn-secondary text-sm" data-testid="broadcast-dryrun"><Eye size={14} /> Trockenlauf</button>
            <div className="flex gap-2 flex-1 min-w-[260px]">
              <input className="sat-input" placeholder="Test an: deine@email.com" value={testTo} onChange={e => setTestTo(e.target.value)} />
              <button onClick={() => send("test")} disabled={busy || !testTo || !subject} className="btn-secondary text-sm" data-testid="broadcast-test"><Send size={14} /> Testmail</button>
            </div>
            <button onClick={() => { if (window.confirm("An ALLE Newsletter-Abonnenten senden?")) send("real"); }} disabled={busy || !subject} className="btn-primary text-sm" data-testid="broadcast-send">
              {busy ? <Loader2 className="animate-spin" size={14} /> : <Send size={14} />} An alle senden
            </button>
          </div>
          {result && (
            <div className="glass rounded-xl p-4 text-sm font-mono text-white/75" data-testid="broadcast-result">
              <pre className="whitespace-pre-wrap">{JSON.stringify(result, null, 2)}</pre>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default BroadcastPage;
